// خريطة المسارات في التطبيق إلى صفحات المساعدة المقابلة في مكتبة الـ Help.
// كل مسار بيتفحص بالترتيب - أول Regex يتطابق هو اللي بيحدد صفحة المساعدة.
// المسارات اللي لسه معندهاش محتوى بترجع لصفحة المساعدة الرئيسية (فاضية = الصفحة الرئيسية).
const HELP_ROUTES = [
  { pattern: /^\/assets\/[^/]+$/, slug: 'assets/details' },
  { pattern: /^\/assets\/?$/, slug: 'assets/list' },
  { pattern: /^\/workorders\/[^/]+$/, slug: 'workorders/details' },
  { pattern: /^\/workorders\/?$/, slug: 'workorders/list' },
  { pattern: /^\/organizations\/[^/]+$/, slug: 'organizations/details' },
  { pattern: /^\/organizations\/?$/, slug: 'organizations/list' },
  { pattern: /^\/jp\/[^/]+$/, slug: 'jp/details' },
  { pattern: /^\/jp\/?$/, slug: 'jp/list' },
  { pattern: /^\/pm\/[^/]+$/, slug: 'pm/details' },
  { pattern: /^\/pm\/?$/, slug: 'pm/list' },
  { pattern: /^\/workflow\/[^/]+$/, slug: 'workflow/details' },
  { pattern: /^\/workflow\/?$/, slug: 'workflow/list' },
  { pattern: /^\/admin\/workflow\/studio\/[^/]+$/, slug: 'action-scripts/details' },
  { pattern: /^\/admin\/workflow\/studio\/?$/, slug: 'action-scripts/list' },
  { pattern: /^\/cobiemanager\/?$/, slug: 'cobie-manager/details' },
  { pattern: /^\/uniimporter\/?$/, slug: 'universal-importer/details' },
  { pattern: /^\/admin\/custom-apps\/[^/]+\/studio$/, slug: 'custom-apps/studio' },
  { pattern: /^\/admin\/custom-apps\/[^/]+\/scripts(\/[^/]+)?$/, slug: 'custom-apps/studio' },
  { pattern: /^\/reportdesigner\/[^/]+$/, slug: 'report-designer/details' },
  { pattern: /^\/smartscheduler\/?$/, slug: 'scheduler/details' },

  // Procurement
  { pattern: /^\/po\/[^/]+$/, slug: 'procurement/po/details' },
  { pattern: /^\/po\/?$/, slug: 'procurement/po/list' },
  { pattern: /^\/pr\/[^/]+$/, slug: 'procurement/pr/details' },
  { pattern: /^\/pr\/?$/, slug: 'procurement/pr/list' },
  { pattern: /^\/rfq\/[^/]+$/, slug: 'procurement/rfq/details' },
  { pattern: /^\/rfq\/?$/, slug: 'procurement/rfq/list' },
  { pattern: /^\/receiving\/[^/]+$/, slug: 'procurement/receiving/details' },
  { pattern: /^\/receiving\/?$/, slug: 'procurement/receiving/list' },
  { pattern: /^\/vendors\/[^/]+$/, slug: 'procurement/vendors/details' },
  { pattern: /^\/vendors\/?$/, slug: 'procurement/vendors/list' },
  { pattern: /^\/invoices\/[^/]+$/, slug: 'procurement/invoices/details' },
  { pattern: /^\/invoices\/?$/, slug: 'procurement/invoices/list' },

  // Inventory
  { pattern: /^\/items\/[^/]+$/, slug: 'inventory/items/details' },
  { pattern: /^\/items\/?$/, slug: 'inventory/items/list' },
  { pattern: /^\/tools\/[^/]+$/, slug: 'inventory/tools/details' },
  { pattern: /^\/tools\/?$/, slug: 'inventory/tools/list' },
  { pattern: /^\/inventory\/[^/]+\/[^/]+$/, slug: 'inventory/balances/details' },
  { pattern: /^\/inventory\/?$/, slug: 'inventory/balances/list' },
  { pattern: /^\/inventoryusage\/[^/]+$/, slug: 'inventory/usage/details' },
  { pattern: /^\/inventoryusage\/?$/, slug: 'inventory/usage/list' },
  { pattern: /^\/mr\/[^/]+$/, slug: 'inventory/mr/details' },
  { pattern: /^\/mr\/?$/, slug: 'inventory/mr/list' },
  { pattern: /^\/storerooms\/[^/]+$/, slug: 'inventory/storerooms/details' },
  { pattern: /^\/storerooms\/?$/, slug: 'inventory/storerooms/list' },
];

// اللغات المدعومة في مكتبة المساعدة (نفس الـ 11 لغة بتاعة i18n في التطبيق)
// mkdocs-static-i18n بيحط اللغة الافتراضية (ar) على الجذر من غير prefix،
// وأي لغة تانية بتاخد prefix باسمها (/en/, /fr/, ...)
const HELP_DEFAULT_LANG = 'ar';
const HELP_SUPPORTED_LANGS = ['en', 'ar', 'fr', 'de', 'it', 'es', 'zh', 'ja', 'ko', 'ru', 'ur'];

const HELP_BASE_PATH = '/help';

/**
 * بيرجع رابط صفحة المساعدة المناسبة للمسار الحالي في التطبيق وباللغة الحالية.
 * لو مفيش تطابق، بيرجع الصفحة الرئيسية لمكتبة المساعدة بنفس اللغة.
 */
export function getHelpUrl(pathname, lang) {
  const match = HELP_ROUTES.find((r) => r.pattern.test(pathname));
  const slug = match ? match.slug : '';
  const langCode = HELP_SUPPORTED_LANGS.includes(lang) ? lang : HELP_DEFAULT_LANG;
  const langPrefix = langCode === HELP_DEFAULT_LANG ? '' : `/${langCode}`;
  const path = slug ? `/${slug}/` : '/';
  return `${HELP_BASE_PATH}${langPrefix}${path}`;
}
